import './App.css';
import { Routes, Route } from 'react-router-dom';

import Home from './pages/Home.js';
import Login from './pages/Login.js';
import Unauthorized from './pages/Unauthorized.js';
import ProtectedRoute from './pages/components/ProtectedRoute.js';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

// Public component
import RemoteSignature from './pages/components/RemoteSignature.js';

// Admin-only
import AddUser from './pages/AddUser.js';
import EditUser from './pages/EditUser.js';
import UserList from './pages/User';
import RoleManagement from './pages/RoleManagement.js';

// Shared components
import AddPatient from './pages/AddPatient.js';
import EditPatient from './pages/EditPatient.js';
import ListPatient from './pages/ListPatient.js';
import MainPage from './pages/MainPage.js';
import AddInventory from './pages/AddInventory.js';
import EditInventory from './pages/EditInventory.js';
import OTBooking from './pages/OTBooking.js';
import AddOtBooking from './pages/AddOtBooking.js';
import EditOtBooking from './pages/EditOtBooking.js';
import OTRooms from './pages/OTRooms.js';
import AddPatientFeedback from './pages/AddPatientFeedback.js';
import VideoRecorder from './pages/components/videorecorder.js';
import AddFile from './pages/AddFile.js';

// Pre-operative
import PreOperative from './pages/PreOperative.js';
import ConsentForAnaestnesia from './pages/PreOperative/ConsenForAnaesthesia.js';
import ConsentForMedical from './pages/PreOperative/ConsentForm.js';
import SurgicalSafetyChecklist from './pages/PreOperative/SurgicalSafetyChecklist.js';


import HighRiskConsentForm from './pages/PreOperative/HighRiskConsentForm.js';
import PreOperativeChecklist from './pages/PreOperative/PreOperativeCheckList';
import ConfirmationPhase from './pages/PreOperative/ConfirmationPhase.js';
import PreoperativeOrders from './pages/PreOperative/PreOperativeOrders.js';
import PreAnaestheticForm from './pages/PreOperative/PreAnaestheticForm.js';
// Intra-operative
import IntraOperative from './pages/IntraOperative.js';
import IntraOperativeNursingRecord from './pages/IntraOperative/IntraOperativeNursingRecord.js';
import OperationSheet from './pages/IntraOperative/OperationSheet.js';
import IntraPostOperativeOrders from './pages/IntraOperative/PostOperativeOrders.js';

// Post-operative
import PostOperative from './pages/PostOperative.js';
import AldreteScore from './pages/PostOperative/AldreteScore.js';
import PostOperativeForm2 from './pages/PostOperative/PostOperative.js';
import PostOperativeOrders from './pages/PostOperative/PostOperativeInstructions.js';
import PostOperativeTable from './pages/PostOperative/PostOperativeAnalgesiaAssessmentChart.js';


// Other
import ConsiderationPhase from './pages/ConsiderationPhase/ConsiderationPhase.js';

import AnesthesiaForm from './pages/PreOperative/AnesthesiaForm';

function App() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path='/' element={<Login />} />
      <Route path='/unauthorized' element={<Unauthorized />} />

      <Route path="/forgot_password" element={<ForgotPassword />} />
      <Route path="/reset_password/:token" element={<ResetPassword />} />


      {/* Admin-only Routes */}
      <Route
        path='/addUser'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'OT Manager']}>
            <AddUser />
          </ProtectedRoute>
        }
      />
      <Route
        path='/editUser/:user_id'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'OT Manager']}>
            <EditUser />
          </ProtectedRoute>
        }
      />
      <Route
        path='/user'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'OT Manager']}>
            <UserList />
          </ProtectedRoute>
        }
      />
      <Route
        path='/roleManagement'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'OT Manager']}>
            <RoleManagement />
          </ProtectedRoute>
        }
      />

      {/* Shared Protected Routes (Admin + Nurse) */}
      <Route
        path='/home'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <Home />
          </ProtectedRoute>
        }
      />
      <Route
        path='/video'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <VideoRecorder />
          </ProtectedRoute>
        }
      />
      <Route
        path='/signature-form/:uhid/:token'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <RemoteSignature />
          </ProtectedRoute>
        }
      />

      <Route
        path='/addPatient'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <AddPatient />
          </ProtectedRoute>
        }
      />
      <Route
        path='/editPatient/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <EditPatient />
          </ProtectedRoute>
        }
      />
      <Route
        path='/listPatient'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <ListPatient />
          </ProtectedRoute>
        }
      />

      <Route
        path='/preoperativeorders/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <PreoperativeOrders />
          </ProtectedRoute>
        }
      />
      <Route
        path='/preInductionAssessment/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <AnesthesiaForm />
          </ProtectedRoute>
        }
      />
      <Route
        path='/mainPage/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <MainPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/addInventory'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'OT Manager']}>
            <AddInventory />
          </ProtectedRoute>
        }
      />
      <Route
        path='/editInventory/:item_id'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'OT Manager']}>
            <EditInventory />
          </ProtectedRoute>
        }
      />
      <Route
        path='/otRooms'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <OTRooms />
          </ProtectedRoute>
        }
      />
      <Route
        path='/otBooking'
        element={
          // <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
          <OTBooking />
          // </ProtectedRoute>
        }
      />

      <Route
        path='/addOtBooking'
        element={
          // <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
          <AddOtBooking />
          // </ProtectedRoute>
        }
      />
      <Route
        path='/editOtBooking/:uhid_no'
        element={
          // <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
          <EditOtBooking />
          // </ProtectedRoute>
        }
      />
      <Route
        path='/addFeedback'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <AddPatientFeedback />
          </ProtectedRoute>
        }
      />

      {/* Pre-Operative Routes */}
      <Route
        path='/preOperative/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <PreOperative />
          </ProtectedRoute>
        }
      />
      <Route
        path='/consentForAnaesthesia/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <ConsentForAnaestnesia />
          </ProtectedRoute>
        }
      />
      <Route
        path='/consentForMedical/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <ConsentForMedical />
          </ProtectedRoute>
        }
      />
      <Route
        path='/surgicalSafetyChecklist/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <SurgicalSafetyChecklist />
          </ProtectedRoute>
        }
      />
      <Route
        path='/preAnaestheticForm/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <PreAnaestheticForm />
          </ProtectedRoute>
        }
      />
      {/* <Route
      //   path='/preAnaestheticForm/:uhid_no'
      //   element={
      //     <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
      //       <PreAnaestheticForm />
      //     </ProtectedRoute>
      //   }
      // />
      <Route
        path='/2'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <PreAnaestheticForm2 />
          </ProtectedRoute>
        }
      /> */}
      <Route
        path='/highRiskConsentForm/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <HighRiskConsentForm />
          </ProtectedRoute>
        }
      />
      <Route
        path='/preOperativeChecklist/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <PreOperativeChecklist />
          </ProtectedRoute>
        }
      />
      <Route
        path='/confirmationPhase/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <ConfirmationPhase />
          </ProtectedRoute>
        }
      />

      {/* Intra-Operative Routes */}
      <Route
        path='/intraOperative/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <IntraOperative />
          </ProtectedRoute>
        }
      />
      <Route
        path='/intraOperativeNursingRecord/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <IntraOperativeNursingRecord />
          </ProtectedRoute>
        }
      />
      <Route
        path='/operationSheet/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <OperationSheet />
          </ProtectedRoute>
        }
      />
      <Route
        path='/intraOperativeOrders/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <IntraPostOperativeOrders />
          </ProtectedRoute>
        }
      />

      {/* Post-Operative Routes */}
      <Route
        path='/postOperative/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <PostOperative />
          </ProtectedRoute>
        }
      />
      <Route
        path='/aldreteScore/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <AldreteScore />
          </ProtectedRoute>
        }
      />
      <Route
        path='/postOperativeForm2/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <PostOperativeForm2 />
          </ProtectedRoute>
        }
      />
      <Route
        path='/postOperativeOrders/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <PostOperativeOrders />
          </ProtectedRoute>
        }
      />
      <Route
        path='/postOperativeAssesment/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <PostOperativeTable />
          </ProtectedRoute>
        }
      />
      <Route
        path='/addfile/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <AddFile />
          </ProtectedRoute>
        }
      />


      <Route
        path='/considerationPhase/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <ConsiderationPhase />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;
